import { AccountCircle } from "@mui/icons-material"
import { Avatar, Box, Link, Typography, useTheme } from "@mui/material"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import analytics from "src/app/analytics"

function logout() {
  localStorage.removeItem("c_at")
  window.location.href =
    "/account/logout?return_url=%2Fapps%2Fcheckout-v3%2Finformation"
}

export default function InformationHeader() {
  const customer = useSelector((state) => state.checkout.customer)
  const theme = useTheme()
  const styles = {
    titleContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        alignItems: "inherit",
        flexDirection: "column",
      },
    },
  }

  useEffect(() => {
    if (customer?.id) {
      analytics.setUserProperties({
        shopify_customer_id: customer.id,
        email: customer.email,
        display_name: customer.displayName,
        first_name: customer.firstName,
        last_name: customer.lastName,
        accepts_marketing: customer.acceptsMarketing,
        logged_in: true,
      })
    }
  }, [customer])

  return (
    <>
      <Box sx={styles.titleContainer}>
        <Box flexGrow={1}>
          <Typography component="h2" variant="h5" gutterBottom>
            Information
          </Typography>
        </Box>
        {!customer?.id && (
          <Box>
            Already have an account?{" "}
            <Link
              href={
                "/account/login?return_url=%2Fapps%2Fcheckout-v3%2Finformation"
              }
            >
              Log in
            </Link>
          </Box>
        )}
      </Box>
      {customer?.id && (
        <Box display="flex" alignItems="center" mb={2}>
          <Box>
            <Avatar variant="rounded" alt={customer.displayName}>
              <AccountCircle />
            </Avatar>
          </Box>
          <Box ml={2}>
            <Typography>
              {customer.displayName} ({customer.email})
            </Typography>
            <Link onClick={logout} sx={{ cursor: "pointer" }}>
              Logout
            </Link>
          </Box>
        </Box>
      )}
    </>
  )
}
